// extracted by mini-css-extract-plugin
module.exports = {"landingVideo":"Landing_landingVideo__2b7Df","homeButton":"Landing_homeButton__1lFNs","eff":"Landing_eff__3MRyV"};